export const mockAssets = {
  vendorStadiumGrill: `${process.env.PUBLIC_URL}/images/mock/vendor-stadium-grill.png`,
  vendorBayBites: `${process.env.PUBLIC_URL}/images/mock/vendor-bay-bites.png`,
  foodBurger: `${process.env.PUBLIC_URL}/images/mock/food-burger.png`,
  foodLemonade: `${process.env.PUBLIC_URL}/images/mock/food-lemonade.png`,
} as const;
